/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IValidationApi {
    validateSendBackPayload(request: ValidateRequest, cancelToken?: CancelToken): AxiosPromise<Payload>;
}

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_ValidationApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_ValidationApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class ValidationApi implements IValidationApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_ValidationApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_ValidationApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    validateSendBackPayload(request: ValidateRequest, cancelToken?: CancelToken): AxiosPromise<Payload> {
        let url_ = "/app/api/Validation/validateurl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<Payload>(options_);
    }
}

export interface Payload {
    emailAddress: string;
    tenantId: string;
    currentPartitionId?: string | undefined;
    extras?: { [key: string]: string; } | undefined;
    brandIds?: string[] | undefined;
}

export interface ValidateRequest {
    encodedMessage: string;
    sign: string;
}
